import { Options } from "vue-class-component";

import config from "@/config/config";
import PageBaseView from "@/pages/PageBaseView";
import { ProductCategory } from "@/domain/product-category.model";

@Options({
  name: "product-category-view",
  props: {
    id: String,
  },
})
export default class ProductCategoryyView extends PageBaseView {
  public row: ProductCategory = {
    description: "",
    enabled: false,
  };

  public mounted(): void {
    this.url = "product-category";
    this.module = config.modules.productCategory;

    this.$store
      .dispatch("productCategory/get", this.id)
      .then((res: ProductCategory) => {
        if (res && res.id) {
          this.row = res;
        } else {
          this.errorMessage = "Registro não encontrado.";
        }
      })
      .catch(() => {
        this.errorMessage = "Registro não encontrado.";
      });
  }
}
